// extracted by mini-css-extract-plugin
export default {"fullWidth":"rOPs2VUTsI3J1yKhlqq6__fullWidth___"};